import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addEveryoneToProject(
    request: Boundaries["addEveryoneToProject"]["request"],
  ): void;
}

function useAddEveryoneToProject(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAddEveryoneToProjectRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAddEveryoneToProjectRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAddEveryoneToProjectRequestFailure,
    ),
    addEveryoneToProject: core.addEveryoneToProject,
  };
}

export { useAddEveryoneToProject };
